import { ContactRequestStatus, SampleRequestStatus } from "../../../api/public";

export const statusToTagColor = (
  status: SampleRequestStatus | ContactRequestStatus
) => {
  switch (status) {
    case SampleRequestStatus.PENDING:
      return "gray";
    case SampleRequestStatus.SUBMITTED:
    case ContactRequestStatus.SUBMITTED:
      return "blue";
    case SampleRequestStatus.ACCEPTED:
    case ContactRequestStatus.ACCEPTED:
      return "green";
    case SampleRequestStatus.REJECTED:
    case ContactRequestStatus.REJECTED:
      return "red";
    default:
      throw new Error("invalid status");
  }
};
